import { Link } from 'react-router';
import { Clock, Phone } from 'lucide-react';
import { useContact } from '@/features/settings/useSiteSettings';

export const HeroMosaic = () => {
  const contact = useContact();

  return (
    <section className="mx-auto w-full max-w-[1220px] px-4 pt-6 sm:px-6 sm:pt-8">
      <div className="grid gap-4 md:grid-cols-3">
        <div className="flex flex-col justify-center rounded-xl bg-paper p-7 sm:p-10 md:col-span-2">
          <h1 className="text-3xl uppercase sm:text-4xl">
            A kényelem
            <br />a gyógyulás
            <span className="block text-teal-ink">az első</span>
          </h1>

          <p className="mt-5 max-w-[40ch] text-lg text-ink-soft">Elektromos betegágy, matrac és betegápolási segédeszközök bérlése otthonra – megbízhatóan, gyorsan, rugalmasan.</p>

          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/rendeles" className="inline-flex min-h-14 items-center gap-2.5 rounded-md border-2 border-navy bg-navy px-7 font-semibold text-cream no-underline hover:border-navy-deep hover:bg-navy-deep">
              Bérlési igény leadása
            </Link>

            <a href={contact.phoneHref} className="inline-flex min-h-14 items-center gap-2.5 rounded-md border-2 border-navy px-7 font-semibold text-navy no-underline hover:bg-navy hover:text-cream">
              <Phone className="size-5" aria-hidden="true" />
              Hívjon most
            </a>
          </div>
        </div>

        <div className="row-span-2 min-h-[280px] overflow-hidden rounded-xl md:min-h-[420px]">
          <img src="/kepek/betegagy-halloszobaban.webp" alt="Elektromos betegágy felállítva egy világos otthoni hálószobában" width={800} height={1000} className="size-full object-cover" />
        </div>

        <div className="flex flex-col justify-between gap-5 rounded-xl bg-navy p-7 text-cream sm:p-8">
          <Clock className="size-11 text-teal-light" aria-hidden="true" />
          <div>
            <p className="font-display text-xl leading-snug font-bold text-cream">Akár néhány órán belül házhoz visszük</p>
            <p className="mt-2 text-sm text-cream/75">Sürgős esetben hívjon minket telefonon, és megbeszéljük a legkorábbi időpontot.</p>
          </div>
        </div>

        <a href={contact.phoneHref} className="flex flex-col justify-center rounded-xl bg-teal p-7 text-navy-deep no-underline hover:bg-teal-light sm:p-8">
          <span className="text-sm font-semibold">Hívjon, mindent elintézünk telefonon</span>
          <span className="mt-1.5 block font-display text-2xl leading-tight font-bold">{contact.phone}</span>
          <span className="mt-1 text-sm opacity-80">
            {contact.weekdayHours}, {contact.weekendHours}
          </span>
        </a>
      </div>
    </section>
  );
};
